import React, { useContext, useState, useEffect } from "react";
import Button from "@mui/material/Button";
import DialogContent from "@mui/material/DialogContent";
import DialogActions from "@mui/material/DialogActions";
import { Avatar, Dialog, Grid, Stack } from "@mui/material";
import { styled } from "@mui/material/styles";
import { Link } from "react-router-dom";
import patientAvatar from "./images/avatar.png";

const TimeChangeDialog = styled(Dialog)(({ theme }) => ({
  "& .MuiDialogContent-root": {
    padding: theme.spacing(4),
  },
  "& .MuiDialogActions-root": {
    padding: theme.spacing(3),
  },
  backdropFilter: "blur(5px)",
  backgroundColor: "rgba(255, 255, 255,0.1)",
}));

const TimeChangeModal = ({ show, handleClose }) => {
  return (
    <div>
      <TimeChangeDialog aria-labelledby="customized-dialog-title" open={show}>
        <DialogContent className="time-change-modal-content">
          <h4>Doctor Suggest Time</h4>
          <Grid item xs={12} md={12} lg={12}>
            <Stack direction="row" spacing={3} className="patientStack">
              <div className="time-change-modal-avatar">
                <Avatar alt="Patient Avatar" src={patientAvatar} />
              </div>
              <div className="doctorName2">
                <h5>
                  Fever Consultation <br />
                  Dr Saman Silva
                </h5>
                <p>Family Physician | Dental Sergeant</p>
                {/* <p>
                  {item?.serviceCategories?.map((category, index) => {
                    if (index === item?.serviceCategories?.length - 1) {
                      return <span key={index}> {category} </span>;
                    } else {
                      return <span key={index}> {category} |</span>;
                    }
                  })}
                </p> */}
              </div>
            </Stack>
          </Grid>
          <h5 className="time-change-modal-time">2021-10-21 at 2.00 PM</h5>
        </DialogContent>
        <DialogActions className="deactivateDialogAction">
          {/* <Link to="/" className="paymentHistoryLink"> */}
          <Button variant="contained" className="time-change-modal-success-btn">
            Confirm
          </Button>
          <p className="time-change-modal-or">Or</p>
          {/* </Link> */}
          <Button
            variant="outlined"
            color="error"
            onClick={handleClose}
            className="time-change-modal-cancel-btn"
          >
            Ignore
          </Button>
        </DialogActions>
      </TimeChangeDialog>
    </div>
  );
};
export { TimeChangeModal };
